import axios from 'axios'
import qs from 'qs'
import Router from 'vue-router'
import router from '@/router'
// 从config/dev.env.js  config/prod.env.js 配置文件中获取环境变量 let DOMAIN =
// process.env.API_ROOT 根据访问的路径更改调用的接口内容

const DEV_ENV = 'https://yunfront.dev.aiyaopai.com'
const PRO_ENV = '//yunfront.aiyaopai.com'

let DOMAIN = DEV_ENV

if (window.location.hostname === 'yun.aiyaopai.com' || window.location.hostname === 'yun.aiyaopai.com' || window.location.hostname === 'yun-src.aiyaopai.com') {
  DOMAIN = PRO_ENV
} else {
  DOMAIN = DEV_ENV
}

// axios默认可修改Cookie
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

// api接口定义
const api = {
  live: {
    combinePicture: 'PublishPicture.Combine', // 拼图功能
    getPhotoDetail: 'PublishPicture.Get', // 获取单个图片详情
    getLiveDetail: 'Activity.Get', //获取直播详情
    getPhotoList: 'PublishPicture.Search', // 获取某个直播的图片列表
    fetchCategory: 'PublishPictureCategory.All', // 查找活动对应的分类列表
    faceRecog: 'PublishPicture.SearchFace', //人脸识别查找图片列表
    getLivePushUrl: 'Activity.GetLivePushUrl', //获取推流地址
    addViewCount: 'Activity.AddViewCount' // 添加浏览量
  },
  user: {
    signInWithWeChat: 'User.SignInWithWeChat', // 微信授权操作
    currentUser: 'User.CurrentUser' // 获取当前用户
  },
  common: {
    getQiniuToken: 'Interact.StorageToken' //获取七牛图片上传令牌
  },
  interaction: {
    publishInteraction: 'Interact.Insert', // 发布互动信息
    getInteractionList: 'Interact.Search', //通过id查询互动列表
    getInteractionDetail: 'Interact.Get', //通过id查询互动详情
    getInteractionLikeList: 'Interact.LikedUserSearch', //通过interId 查询点赞列表
    getInteractionCommentList: 'InteractComment.Search', //通过interId 查询评论列表
    unLike: 'Interact.UnLike', //取消点赞
    like: 'Interact.Like', //点赞
    checkLike: 'Interact.LikedExists', // 检查点赞状态
    addComment: 'InteractComment.Insert', //添加评论
    delete: 'Interact.Delete' //删除互动
  }
}

/**
 * 获取单个图片详情
 * @param {*} pId
 */
const getPhotoDetail = pId => {
  let data = {
    api: api.live.getPhotoDetail,
    id: pId,
    fields: 'ActivityId,Ave,Height,Id,IsLarge,OriginalAt,Size,Title,Url,Width'
  }
  return new Promise((resolve, reject) => {
    axios
      .post(DOMAIN, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 添加活动浏览量
 * @param {*} liveId
 */
const addViewCount = liveId => {
  let data = {
    api: api.live.addViewCount,
    id: liveId
  }
  return new Promise((resolve, reject) => {
    axios
      .post(DOMAIN, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 查找指定活动照片分类
 * @param {*} activityId
 */
const fetchCategory = function (activityId) {
  let data = {
    activityId: activityId,
    fields: 'Id,Name,ActivityId,OrderNumber'
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}?api=${api.live.fetchCategory}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
      .catch(err => {
        console.log(err.response)
        reject(err)
      })
  })
}

/**
 * 拼图
 * @param {*} ids
 * @param {*} liveId
 */
const combinePicture = (ids, liveId) => {
  let data = {
    api: api.live.combinePicture,
    ids: ids,
    activityId: liveId
  }

  return new Promise((resolve, reject) => {
    axios
      .post(DOMAIN, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
      .catch(err => {
        console.log(err.response)
        reject(err)
      })
  })
}

/**
 * 获取直播推流地址
 * @param {*} url
 */
const getLivePushUrl = function (url) {
  let data = {
    pushId: url
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}?api=${api.live.getLivePushUrl}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        console.log('异常信息：', err.response)
      })
  })
}

/**
 * 获取直播详情
 * @param {直播Id} liveId
 * @param {cb} cb
 */
const getLiveDetail = function (liveId, router, cb) {
  let data = {
    id: liveId,
    fields:
      'Id,LargePictureSeparatedEnabled,Title,SubTitle,ViewsEnable,JigsawEnabled,BannerExternalName,EncryptEnabled,EncryptPassword,LivePushStreamUrl,LivePullStreamUrl,LiveEnabled,FaceEnabled,Watermark,BannerVideo,SubscribeDisabled,BannerExternalVideoUrl,ShareLogo,Banner,LoadingImage,FlashScreenImage,ViewC' +
      'ount,PublishPicturesCount,SponsorTitle,CopyrightDisplay,DescriptionTitle,BeginAt' +
      ',EndAt,Address,Description,Sponsors.Name,Sponsors.QrCode,Sponsors.Id,Sponsors.De' +
      'scription,Sponsors.Logo,Logo,ParticipatorDisabled,InteractDisabled'
  }

  axios
    .post(`${DOMAIN}?api=${api.live.getLiveDetail}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      // console.log(err.response)
      router.push({
        name: 'error',
        query: {
          code: err.response.data.Code,
          message: err.response.data.Message
        }
      })
    })
}

/**
 * 人脸识别接口
 * @param {* 直播Id} liveId
 * @param {* 大头照图片} url
 */
const faceRecog = function (liveId, url) {
  return new Promise((resolve, reject) => {
    let data = {
      activityId: liveId,
      url: url,
      fields:
        'Id,Width,Height,UpdatedAt,Title,IsLarge,OriginalAt,Size,Url,CategoryId'
    }
    axios
      .post(`${DOMAIN}?api=${api.live.faceRecog}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res) {
          resolve(res)
        }
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

/**
 * 获取活动图片列表
 * @param {*} liveId
 * @param {*} pageIndex
 * @param {*} pageSize
 * @param {*} cb
 */
const getPhotoList = (args, cb) => {
  let data = {
    IsLarge: args.option.isLarge,
    categoryId: args.option.categoryId,
    activityId: args.option.liveId,
    pageSize: args.option.pageSize,
    pageIndex: args.option.pageIndex,
    fields: 'Id,ActivityId,Url,Width,Height,IsLarge,Title,OriginalAt,Size,Ave'
  }

  axios
    .post(`${DOMAIN}?api=${api.live.getPhotoList}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      console.log(err.response)
    })
}

/**
 * 微信授权
 * @param {*} refresh_token
 */
const signInWithWeChat = (refresh_token, cb) => {
  let data = {
    api: api.user.signInWithWeChat,
    refreshToken: refresh_token
  }
  axios
    .post(`${DOMAIN}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      console.log(err.response)
    })
}

/**
 * 获取当前用户
 * @param {*} cb
 */
const getCurrentUser = cb => {
  let data = {
    api: api.user.currentUser,
    fields: 'Id,Nickname,Avatar'
  }
  axios
    .post(`${DOMAIN}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      console.log('捕获的错误1：', err.response)
      cb(err)
    })
}

/**
 * 获取七牛令牌操作
 * @param {*} cb
 */
const getQiniuToken = cb => {
  let data = {
    api: api.common.getQiniuToken
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

const getInteractionList = (activityId, pageIndex, pageSize, userId) => {
  let data = {}
  if (userId) {
    data = {
      api: api.interaction.getInteractionList,
      fields:
        'Id,CreatedAt,Title,LikesCount,Picture,UserId,User.Nickname,User.Avatar',
      pageSize: pageSize,
      pageIndex: pageIndex,
      activityId: activityId,
      userId: userId
    }
  } else {
    data = {
      api: api.interaction.getInteractionList,
      fields:
        'Id,CreatedAt,Title,LikesCount,Picture,UserId,User.Nickname,User.Avatar',
      pageSize: pageSize,
      pageIndex: pageIndex,
      activityId: activityId
    }
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res)
        }
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 发布互动信息接口
 * @param {*} title
 * @param {*} picture
 * @param {*} activityId
 * @param {*} cb
 */
const publishInteraction = (title, picture, activityId, cb) => {
  let data = {
    api: api.interaction.publishInteraction,
    title: title,
    picture: picture,
    activityId: activityId
  }

  axios
    .post(`${DOMAIN}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      console.log(err.response)
    })
}

/**
 * 查询互动信息详情
 * @param {*} id
 * @param {*} cb
 */
const getInteractionDetail = (id, cb) => {
  let data = {
    api: api.interaction.getInteractionDetail,
    id: id,
    fields:
      'Id,CreatedAt,Picture,Title,LikesCount,ActivityId,UserId,User.Nickname,User.Avata' +
      'r'
  }
  axios
    .post(`${DOMAIN}`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      cb(res)
    })
    .catch(err => {
      console.log(err.response)
      // router.replace({path: '/error'})
    })
}

/**
 * 获取点赞列表
 * @param {*} id
 * @param {*} pageIndex
 * @param {*} pageSize
 * @param {*} cb
 */
const getInteractionLikeList = (id, pageIndex, pageSize) => {
  let data = {
    api: api.interaction.getInteractionLikeList,
    fields: 'Id,CreatedAt,Nickname,Avatar',
    pageIndex: pageIndex,
    pageSize: pageSize,
    interactId: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 获取评论列表
 * @param {*} id
 * @param {*} pageIndex
 * @param {*} pageSize
 * @param {*} cb
 */
const getInteractionCommentList = (id, pageIndex, pageSize) => {
  let data = {
    api: api.interaction.getInteractionCommentList,
    fields: 'Id,CreatedAt,User.Nickname,User.Avatar,Content,UserId',
    pageIndex: pageIndex,
    pageSize: pageSize,
    interactId: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 取消点赞
 * @param {*} id
 */
const unLike = id => {
  let data = {
    api: api.interaction.unLike,
    interactId: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.Success) {
            resolve()
          }
        }
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 点赞操作
 * @param {*} id
 */
const like = id => {
  let data = {
    api: api.interaction.like,
    interactId: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.Success) {
            resolve()
          }
        }
      })
      .catch(err => {
        console.log(err.response)
      })
  })
}

/**
 * 添加评论
 * @param {*} id
 * @param {*} content
 */
const addComment = (id, content) => {
  let data = {
    api: api.interaction.addComment,
    content: content,
    interactId: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 201) {
          if (res.data.Id) {
            resolve(res.data.Id)
          }
        }
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 删除互动
 * @param {*} id
 */
const removeInteraction = id => {
  let data = {
    api: api.interaction.delete,
    id: id
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          if (res.data.Success) {
            resolve()
          }
        }
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

/**
 * 检查登录状态
 * @param {*} UID
 * @param {*} IID
 */
const checkLike = (UID, IID) => {
  let data = {
    api: api.interaction.checkLike,
    UserId: UID,
    interactId: IID
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN}`, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(res => {
        if (res.status == 200) {
          resolve(res.data.Result)
        }
      })
      .catch(err => {
        reject(err)
        console.log(err.response)
      })
  })
}

export default {
  live: {
    combinePicture: combinePicture,
    getPhotoDetail: getPhotoDetail,
    addViewCount: addViewCount,
    getLivePushUrl: getLivePushUrl,
    fetchCategory: fetchCategory,
    faceRecog: faceRecog,
    getLiveDetail: getLiveDetail,
    getPhotoList: getPhotoList,
    publishInteraction: publishInteraction,
    getInteractionList: getInteractionList,
    getInteractionDetail: getInteractionDetail,
    getInteractionLikeList: getInteractionLikeList,
    getInteractionCommentList: getInteractionCommentList,
    removeInteraction: removeInteraction,
    like: like,
    unLike: unLike,
    checkLike: checkLike,
    addComment: addComment
  },
  user: {
    signInWithWeChat: signInWithWeChat,
    getCurrentUser: getCurrentUser
  },
  base: {
    getQiniuToken: getQiniuToken
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js